<template>
<div class="k-page-content" v-loading="loading">
	<div class="messageContent">
		<div class="title">{{info.title}}</div>
		<div class="tips">
			<span style="margin-right: 30px;">发布时间：{{info.create_time}}</span><span>来自于：{{info.uid_txt}}</span>
		</div>
		<div class="box" v-html="info.content">
		</div>
	</div>
</div>
</template>
<script>
export default {
  data() {
      return {
		  loading:false,
		  queryParams:{},
		  info:{}
      }
	},
	computed: {
		
	},
	mounted: function () {
		this.loading = true
		this.queryParams = this.$route.query;
		this.getDetail()
	},
	methods: {
		getDetail(){
			this.$api.get('/admin/news/message/getnoticeinfo',{id:this.queryParams.id}).then(res => {
			  if (res.code === 0) {
				  this.info = res.data
			  } else {
				 this.$message.error(res.msg);
			  }
			  this.loading = false
			})
		}
	}
}
</script>
<style lang="scss" scoped>
	
</style>